var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.resizeCanvasToView),expression:"resizeCanvasToView"}],attrs:{"id":"glyph-canvas"}})}
var staticRenderFns = []

export { render, staticRenderFns }